import {loginUserStore} from "./Login/LoginUserStore";

const store = {
  loginUserStore,
};

export default store
